angular.module('impactx.scheduler').directive('ixSchedulerFrequency', function () {
    return {
        scope: {
            frequency: "=",
            dialogData: "=",
            schedulerWarningMessage: "="
        },
        restrict: 'E',
        controller: 'SchedulerFrequencyCtrl',
        controllerAs: 'schedulerFrequencyCtrl',
        templateUrl: 'shared/scheduler/templates/frequency.html'
    };
});